"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlanDetailsReact = exports.PlanDetails = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _store = require("../store");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("./components");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PlanDetailsReact = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(PlanDetailsReact, _React$PureComponent);
  var _super = _createSuper(PlanDetailsReact);
  function PlanDetailsReact() {
    (0, _classCallCheck2.default)(this, PlanDetailsReact);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(PlanDetailsReact, [{
    key: "render",
    value: function render() {
      var document = this.props.document;
      var isInterestFree = document.isInterestFree,
        isPRP = document.isPRP,
        application = document.application,
        isIL = document.isIL,
        clientId = document.clientId;
      var trimmedPhone = application.trimmedPhone,
        firstName = application.firstName,
        email = application.email,
        lastName = application.lastName,
        loanAmount = application.loanAmount,
        introTerm = application.introTerm,
        payment = application.payment,
        rate = application.rate,
        physicalCity = application.physicalCity,
        physicalState = application.physicalState,
        physicalAddress1 = application.physicalAddress1,
        physicalZip = application.physicalZip,
        dateOfBirth = application.dateOfBirth,
        totalIncome = application.totalIncome,
        grossSalary = application.grossSalary,
        grossOtherIncome = application.grossOtherIncome;
      var adsNIRApr = '26.99';
      var titleText = '';
      var isIFOrPRP = isInterestFree || isPRP;
      var term = isIL ? application.term : application.introTerm;

      /* Example if (getPlans && !isInterestFree && isPRP && getPlans.ilStatus === 'APPROVED') { */
      // if (!isInterestFree && isPRP && ilStatus === 'APPROVED') {
      //   titleText = 'Please review your option before submitting.';
      // } else {
      if (isInterestFree || isPRP) {
        titleText = 'Please review your option before clicking "Confirm and Apply".';
      } else {
        titleText = 'Please review your option before submitting.';
      }
      // }

      var getPlanDetailsHeading = function getPlanDetailsHeading() {
        var sectionDebrief = isIFOrPRP && /*#__PURE__*/_react.default.createElement("div", {
          className: "term"
        }, "By applying you will be providing your personal information to Comenity Capital Bank, the issuer of Lending Club Patient Solutions Credit Accounts. To apply you must: be at least 18 years of age; be a U.S. resident residing in the United States; have a U.S. Social Security Number; have a street address, rural route or APO/FPO mailing address; and have a valid govt-issued photo ID.");
        var contentHeading = isIFOrPRP && /*#__PURE__*/_react.default.createElement("div", {
          className: "sub-title"
        }, "Your Application for a Lending Club Patient Solutions credit account:");
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "plan-heading"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "heading"
        }, titleText, /*#__PURE__*/_react.default.createElement("br", null), isIFOrPRP && /*#__PURE__*/_react.default.createElement("span", {
          className: "red-text"
        }, "(Credit check required)")), /*#__PURE__*/_react.default.createElement("span", {
          className: "privacy-security"
        }), sectionDebrief, contentHeading);
      };
      var getILContent = function getILContent() {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "il-content"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "clearfix"
        }, /*#__PURE__*/_react.default.createElement("span", null, "Fixed Rate Plan"), /*#__PURE__*/_react.default.createElement("div", {
          className: "name"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "label"
        }, "Applicant name:"), /*#__PURE__*/_react.default.createElement("span", null, firstName, " ", lastName)), /*#__PURE__*/_react.default.createElement("div", {
          className: "col"
        }, /*#__PURE__*/_react.default.createElement("div", null, "Amount Financed"), /*#__PURE__*/_react.default.createElement("div", null, loanAmount)), /*#__PURE__*/_react.default.createElement("div", {
          className: "col"
        }, /*#__PURE__*/_react.default.createElement("div", null, "Monthly payment"), /*#__PURE__*/_react.default.createElement("div", null, payment)), /*#__PURE__*/_react.default.createElement("div", {
          className: "col"
        }, /*#__PURE__*/_react.default.createElement("div", null, "Number of payments"), /*#__PURE__*/_react.default.createElement("div", null, term)), /*#__PURE__*/_react.default.createElement("div", {
          className: "col last"
        }, /*#__PURE__*/_react.default.createElement("div", null, "Annual Percentage Rate"), /*#__PURE__*/_react.default.createElement("div", null, rate, "%"))), /*#__PURE__*/_react.default.createElement("div", {
          className: "list-square-ul"
        }, /*#__PURE__*/_react.default.createElement("ul", {
          className: "list-square red-bullet"
        }, /*#__PURE__*/_react.default.createElement("li", null, "No prepayment penalty"), /*#__PURE__*/_react.default.createElement("li", null, "No upfront payment needed"), /*#__PURE__*/_react.default.createElement("li", null, "No payment due for 3 - 7 weeks"))));
      };
      var getIFOrPRPContent = function getIFOrPRPContent() {
        var planOption = '';
        if (isInterestFree) {
          planOption = "Plan Option: ".concat(_components.planConstants.INTEREST_FREE_LOAN.displayName, " for ").concat(introTerm, " months - after that ").concat(adsNIRApr, "% standard APR*");
        } else if (isPRP) {
          planOption = "Plan Option: ".concat(_components.planConstants.PROMOTIONAL_RATE_LOAN.displayName, " for ").concat(introTerm, " months - after that ").concat(adsNIRApr, "% standard APR*");
        } else {
          planOption = '';
        }
        var pi1URL = "/patientsolutions/app/check-your-rate?clientid=".concat(clientId);
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "M-B-20 if-box"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "if-box-container automargin"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "Fw-b title"
        }, planOption), /*#__PURE__*/_react.default.createElement("div", {
          className: "underline"
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "details"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "row grid-u clearfix"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col label"
        }, /*#__PURE__*/_react.default.createElement("label", {
          className: "Fz-m Fw-l section-heading"
        }, "Applicant name:")), /*#__PURE__*/_react.default.createElement("div", {
          className: "col"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "Fw-b right"
        }, firstName, " ", lastName))), /*#__PURE__*/_react.default.createElement("div", {
          className: "row grid-u clearfix"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col label"
        }, /*#__PURE__*/_react.default.createElement("label", {
          className: "Fz-m Fw-l section-heading"
        }, "Date of Birth:")), /*#__PURE__*/_react.default.createElement("div", {
          className: "col"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "Fw-b right"
        }, dateOfBirth))), /*#__PURE__*/_react.default.createElement("div", {
          className: "row grid-u clearfix"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col label"
        }, /*#__PURE__*/_react.default.createElement("label", {
          className: "Fz-m Fw-l section-heading"
        }, "SSN:")), /*#__PURE__*/_react.default.createElement("div", {
          className: "col"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "Fw-b right"
        }, "***-**-****"))), /*#__PURE__*/_react.default.createElement("div", {
          className: "row grid-u clearfix"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col label"
        }, /*#__PURE__*/_react.default.createElement("label", {
          className: "Fz-m Fw-l section-heading"
        }, "Home Address:")), /*#__PURE__*/_react.default.createElement("div", {
          className: "col"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "Fw-b right D-b"
        }, physicalAddress1), /*#__PURE__*/_react.default.createElement("span", {
          className: "Fw-b right"
        }, physicalCity, ", ", physicalState, ", ", physicalZip))), /*#__PURE__*/_react.default.createElement("div", {
          className: "row grid-u clearfix email"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col label"
        }, /*#__PURE__*/_react.default.createElement("label", {
          className: "Fz-m Fw-l section-heading"
        }, "Email:")), /*#__PURE__*/_react.default.createElement("div", {
          className: "col"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "Fw-b right"
        }, email))), /*#__PURE__*/_react.default.createElement("div", {
          className: "row grid-u clearfix Pos-R phone"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col label"
        }, /*#__PURE__*/_react.default.createElement("label", {
          className: "Fz-m Fw-l section-heading"
        }, "Primary Phone Number:")), /*#__PURE__*/_react.default.createElement("div", {
          className: "col"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "Fw-b right"
        }, trimmedPhone))), /*#__PURE__*/_react.default.createElement("div", {
          className: "row grid-u clearfix Pos-R phone"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col label"
        }, "\xA0"), /*#__PURE__*/_react.default.createElement("div", {
          className: "col msg"
        }, /*#__PURE__*/_react.default.createElement("span", null, "By providing your contact information, including any cellular or other phone numbers, you agree to be contacted regarding any of your Comenity Bank or Comenity Capital Bank accounts via calls to cell phones, text messages or telephone calls, including the use of artificial or pre-recorded message calls, and calls made via automatic telephone dialing systems, or via e-mail."))), /*#__PURE__*/_react.default.createElement("div", {
          className: "row grid-u clearfix Pos-R"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col label"
        }, /*#__PURE__*/_react.default.createElement("label", {
          className: "Fz-m Fw-l section-heading"
        }, "Gross Individual Yearly Income:")), /*#__PURE__*/_react.default.createElement("div", {
          className: "col amount"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "Fw-b right"
        }, grossSalary))), /*#__PURE__*/_react.default.createElement("div", {
          className: "row grid-u clearfix Pos-R"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col label"
        }, /*#__PURE__*/_react.default.createElement("label", {
          className: "Fz-m Fw-l section-heading"
        }, "+ Additional Yearly Income:")), /*#__PURE__*/_react.default.createElement("div", {
          className: "col amount"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "Fw-b right"
        }, grossOtherIncome))), /*#__PURE__*/_react.default.createElement("div", {
          className: "row divider"
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "row grid-u clearfix income Pos-R"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col label"
        }, /*#__PURE__*/_react.default.createElement("label", {
          className: "Fz-m Fw-l section-heading"
        }, "= Total gross yearly income:")), /*#__PURE__*/_react.default.createElement("div", {
          className: "col amount"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "Fw-b right"
        }, totalIncome))), /*#__PURE__*/_react.default.createElement("div", {
          className: "row grid-u clearfix Pos-R"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col label"
        }, "\xA0"), /*#__PURE__*/_react.default.createElement("div", {
          className: "col msg"
        }, /*#__PURE__*/_react.default.createElement("span", null, "Alimony, child support or separate maintenance income need not be included if you do not wish to have it considered as a basis for repaying this obligation. Married WI Residents only: If you are applying for an individual account and your spouse also is a WI resident, combine your and your spouse's financial information.")))), /*#__PURE__*/_react.default.createElement("div", null, "If this information is inaccurate, please ", /*#__PURE__*/_react.default.createElement("a", {
          href: pi1URL
        }, "click here"), " to start a new application")));
      };
      var getPlanContent = typeof isIL === 'boolean' ? isIL ? getILContent() : getIFOrPRPContent() : '';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "plan-container"
      }, getPlanDetailsHeading(), getPlanContent);
    }
  }]);
  return PlanDetailsReact;
}(_react.default.PureComponent);
exports.PlanDetailsReact = PlanDetailsReact;
var mapStateToProps = function mapStateToProps(state) {
  return {
    document: state.document
  };
};
PlanDetailsReact.propTypes = {
  document: _propTypes.default.object.isRequired
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var PlanDetails = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PlanDetailsReact);
exports.PlanDetails = PlanDetails;
